module.exports = __webpack_public_path__ + "static/img/header_mPic_01.aeb1a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/mobile/header_mPic_01.png
// module id = Kz2z
// module chunks = 0